export default __webpack_public_path__ + "media/Non-food.4e1d278f.png";